// 共通の型定義とユーティリティ関数
export const GENDER_TYPES: Record<string, string> = {
  'MALE': '男性',
  'FEMALE': '女性',
  'OTHER': 'その他'
};
export const getGenderLabel = (genderType: string): string => {
  return GENDER_TYPES[genderType] || genderType;
};
export const PREFECTURE_TYPES: Record<string, string> = {
  'HOKKAIDO': '北海道',
  'AOMORI': '青森県',
  'IWATE': '岩手県',
  'MIYAGI': '宮城県',
  'AKITA': '秋田県',
  'YAMAGATA': '山形県',
  'FUKUSHIMA': '福島県',
  'IBARAKI': '茨城県',
  'TOCHIGI': '栃木県',
  'GUNMA': '群馬県',
  'SAITAMA': '埼玉県',
  'CHIBA': '千葉県',
  'TOKYO': '東京都',
  'KANAGAWA': '神奈川県',
  'NIIGATA': '新潟県',
  'TOYAMA': '富山県',
  'ISHIKAWA': '石川県',
  'FUKUI': '福井県',
  'YAMANASHI': '山梨県',
  'NAGANO': '長野県',
  'GIFU': '岐阜県',
  'SHIZUOKA': '静岡県',
  'AICHI': '愛知県',
  'MIE': '三重県',
  'SHIGA': '滋賀県',
  'KYOTO': '京都府',
  'OOSAKA': '大阪府',
  'HYOGO': '兵庫県',
  'NARA': '奈良県',
  'WAKAYAMA': '和歌山県',
  'TOTTORI': '鳥取県',
  'SHIMANE': '島根県',
  'OKAYAMA': '岡山県',
  'HIROSHIMA': '広島県',
  'YAMAGUCHI': '山口県',
  'TOKUSHIMA': '徳島県',
  'KAGAWA': '香川県',
  'EHIME': '愛媛県',
  'KOUCHI': '高知県',
  'FUKUOKA': '福岡県',
  'SAGA': '佐賀県',
  'NAGASAKI': '長崎県',
  'KUMAMOTO': '熊本県',
  'OOITA': '大分県',
  'MIYAZAKI': '宮崎県',
  'KAGOSHIMA': '鹿児島県',
  'OKINAWA': '沖縄県',
  'FOREIGN': '海外'
};
export const getPrefectureLabel = (prefectureType: string): string => {
  return PREFECTURE_TYPES[prefectureType] || prefectureType;
};
// 就労状況の日本語変換
export const EMPLOYMENT_TYPES: Record<string, string> = {
  'WORKING': '就労中',
  'LEAVE': '休職中',
  'NONE': '働いていない'
};
// 就労状況を日本語に変換する関数
export const getEmploymentLabel = (employmentType: string | null): string => {
  if (!employmentType) return '未設定';
  return EMPLOYMENT_TYPES[employmentType] || employmentType;
};
// 生年月日から年齢を計算する関数
export const calculateAge = (birthday: string): number => {
  const birthDate = new Date(birthday);
  const today = new Date();
  let age = today.getFullYear() - birthDate.getFullYear();
  const monthDiff = today.getMonth() - birthDate.getMonth();
  // 誕生月がまだ来ていない、または誕生月だが誕生日がまだ来ていない場合は1歳引く
  if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) {
    age--;
  }
  return age;
};
// メッセージ表示の文字数制限
export const MESSAGE_DISPLAY_LIMIT = 17;
// 開発者モードのテーマカラー
export const DEVELOPER_THEME = {
  // クラシックブラウンテーマ
  BACKGROUND: '#efebe9',      // 薄いブラウン
  BACKGROUND_ALPHA: 'rgba(239, 235, 233, 0.5)',
  BORDER: '#bcaaa4',          // 中間のブラウン
  BORDER_ALPHA: 'rgba(121, 85, 72, 0.5)',
  BORDER_LIGHT_ALPHA: 'rgba(121, 85, 72, 0.3)',
  DARK: '#795548',            // 濃いブラウン（アクセント用）
  DARK_ALPHA: 'rgba(121, 85, 72, 0.7)',
  TEXT: 'rgba(239, 235, 233, 0.8)'  // テキスト色（薄いブラウン、白っぽく）
};
// 共通テーブルテーマカラー
export const TABLE_THEME = {
  HEADER: {
    BACKGROUND: '#f0f5ff',    // ヘッダー背景色（薄い水色）
    BORDER: '#e0e0ff',        // ヘッダーボーダー色
    TEXT: '#333333',          // ヘッダーテキスト色
  },
  ROW: {
    HOVER: 'rgba(0, 0, 0, 0.04)', // 行ホバー時の背景色
    BORDER: '#f0f0f0',            // 行ボーダー色
  }
};

// 退会状態
export enum ResignationStatus {
  INCLUDE_RESIGNED = 'true',  // 退会済みを含む
  ACTIVE_ONLY = 'false',      // 有効ユーザーのみ（デフォルト）
  RESIGNED_ONLY = 'only'      // 退会済みのみ
}

// 退会状態の表示名
export const RESIGNATION_STATUS_DISPLAY = {
  [ResignationStatus.INCLUDE_RESIGNED]: '退会済みを含む',
  [ResignationStatus.ACTIVE_ONLY]: '有効ユーザーのみ',
  [ResignationStatus.RESIGNED_ONLY]: '退会済みのみ'
};
